/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'sendMessage': {
    width: 18,
    height: 15,
    viewBox: '0 0 18 15',
    data: '<path pid="0" d="M.361.002a.405.405 0 0 0-.323.57l3.167 6.929-3.167 6.922a.406.406 0 0 0 .526.545l16.973-7.075.05-.019a.406.406 0 0 0 .115-.67.417.417 0 0 0-.026-.026.405.405 0 0 0-.107-.057L.564.034A.405.405 0 0 0 .36.002zm.842 1.178l14.2 5.915H3.908L1.203 1.18zm2.705 6.726h11.495l-14.2 5.916 2.705-5.916z" _fill="#C4C4C4"/>'
  }
})
